{
  "auth": {
    "agree": "Ich stimme zu",
    "createAccount": "Konto erstellen",
    "createNewAccount": "Neues Konto erstellen",
    "email": "E-Mail",
    "login": "Anmelden",
    "password": "Passwort",
    "recover_password": "Passwort wiederherstellen",
    "sign_up": "Registrieren",
    "keep_logged_in": "Angemeldet bleiben",
    "termsOfUse": "Nutzungsbedingungen.",
    "reset_password": "Passwort zurücksetzen"
  },
  "404": {
    "title": "Diese Seite ist nicht verfügbar.",
    "text": "Wenn Sie glauben, dass etwas nicht stimmt, senden Sie uns bitte eine Nachricht an ",
    "back_button": "Zurück zum Dashboard"
  },
  "typography": {
    "primary": "Primäre Textstile",
    "secondary": "Sekundäre Textstile"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Remote-Verbindungen einrichten",
    "currentVisitors": "Aktuelle Besucher",
    "navigationLayout": "Navigationslayout",
    "topBarButton": "Oberes Menü",
    "sideBarButton": "Seitenleiste"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "history": "Logs",
    "user_action_log": "Benutzeraktionen",
    "bucket_history": "Dateiaktionen",

    "files": "Dateien",
    "auth": "Authentifizierung",
    "buttons": "Schaltflächen",
    "timelines": "Zeitachsen",
    "dashboard": "Dashboard",
    "billing": "Abrechnung",
    "login": "Anmelden",
    "preferences": "Kontoeinstellungen",
    "payments": "Zahlungen",
    "settings": "Einstellungen",
    "pricing-plans": "Preismodelle",
    "payment-methods": "Zahlungsmethoden",
    "signup": "Registrierung",
    "recover-password": "Passwort wiederherstellen",
    "recover-password-email": "Passwort wiederherstellen email",
    "404": "404",
    "faq": "FAQ",
    "users": "Accounts",
    "projects": "Projekte"
  },
  "messages": {
    "all": "Alle Nachrichten anzeigen",
    "new": "New messages from {name}",
    "mark_as_read": "Als gelesen markieren"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "Alle Benachrichtigungen anzeigen",
    "less": "Weniger Benachrichtigungen anzeigen",
    "mark_as_read": "Als gelesen markieren",
    "sentMessage": "hat dir eine Nachricht gesendet",
    "uploadedZip": "hat eine neue Zip-Datei mit {type} hochgeladen",
    "startedTopic": "hat ein neues Thema gestartet"
  },

  "files": {
    "title": "Dateien",
    "folderNameLabel": "Ordnername",
    "uploading": "Hochladen...",
    "upload": "Hochladen",
    "rootFolder": "Root-Ordner",
    "confirmDeleteTitle": "Löschen bestätigen",
    "confirmDeleteMessage": "Möchtest du wirklich löschen",
    "confirmDeleteCancel": "Abbrechen",
    "confirmDeleteOk": "Löschen",
    "createFolderTitle": "Ordner erstellen",
    "createFolderLabel": "Ordnername",
    "createFolderCancel": "Abbrechen",
    "createFolderOk": "Erstellen"
  },

  "history": {
    "fromDate": "Von-Datum",
    "toDate": "Bis-Datum",
    "title": "Bucket-Verlauf",
    "clearAll": "Alle löschen",
    "downloadAll": "Alle herunterladen",
    "search": "Suchen",
    "reset": "Zurücksetzen",
    "path": "Pfad",
    "user": "Benutzer",
    "action": "Aktion",
    "searchPath": "Nach Pfad suchen",
    "searchUser": "Nach Benutzer suchen",
    "searchAction": "Nach Aktion suchen",
    "loading": "Verlauf wird geladen...",
    "deleteTitle": "Eintrag löschen",
    "deleteConfirm": "Möchtest du diesen Eintrag wirklich löschen?",
    "delete": "Löschen",
    "cancel": "Abbrechen",
    "clearAllTitle": "Gesamten Verlauf löschen",
    "clearAllConfirm": "Dies wird den gesamten Bucket-Verlauf dauerhaft löschen. Fortfahren?",
    "confirmDeleteAll": "Ja, alles löschen",
    "toastLoadError": "Verlauf konnte nicht geladen werden",
    "toastDeleteSuccess": "Eintrag gelöscht",
    "toastDeleteError": "Eintrag konnte nicht gelöscht werden",
    "toastClearSuccess": "Verlauf gelöscht",
    "toastClearError": "Verlauf konnte nicht gelöscht werden",
    "toastDownloadError": "Verlauf konnte nicht heruntergeladen werden",
    "date": "Datum"
  },

  "user_action": {
    "title": "Benutzeraktionsprotokoll",
    "username": "Benutzername",
    "action": "Aktion",
    "fromDate": "Von Datum",
    "toDate": "Bis Datum",
    "search": "Suchen",
    "reset": "Zurücksetzen",
    "searchUser": "Nach Benutzer suchen",
    "searchAction": "Aktionstyp",
    "loading": "Protokolle werden geladen...",
    "deleteTitle": "Eintrag löschen",
    "deleteConfirm": "Möchtest du diesen Protokolleintrag wirklich löschen?",
    "delete": "Löschen",
    "cancel": "Abbrechen",
    "changeDetails": "Änderungsdetails",
    "toastFetchError": "Protokolle konnten nicht geladen werden",
    "toastDeleteSuccess": "Eintrag gelöscht",
    "toastDeleteError": "Eintrag konnte nicht gelöscht werden"
  },

  "profile": {
    "username": "Benutzername",
    "email": "E-Mail",
    "password": "Passwort",
    "resetPassword": "Passwort zurücksetzen",
    "2faTitle": "Zwei-Faktor-Authentifizierung",
    "2faModalTitle": "Zwei-Faktor-Authentifizierung",
    "2faEnableInstruction": "Scanne den QR-Code mit deiner Authenticator-App und gib anschließend den 6-stelligen Code ein.",
    "2faCodeLabel": "Authentifikator-Code",
    "2faCodePlaceholder": "6-stelligen Code eingeben",
    "cancel": "Abbrechen",
    "enable2fa": "2FA aktivieren",
    "disable2fa": "2FA deaktivieren",
    "setup2fa": "2FA einrichten",
    "2faEnabledText": "Die Zwei-Faktor-Authentifizierung (2FA) ist für dein Konto aktiviert und bietet zusätzlichen Schutz beim Anmelden.",
    "2faDisabledText": "Füge deinem Konto eine zusätzliche Sicherheitsebene hinzu. Zum Anmelden benötigst du dann einen Code sowie deinen Benutzernamen und dein Passwort.",
    "2faEnabledToast": "2FA erfolgreich aktiviert",
    "2faDisabledToast": "2FA deaktiviert",
    "2faInitFailed": "2FA konnte nicht initialisiert werden",
    "2faFailed": "2FA fehlgeschlagen",
    "2faSuccessEnabled": "2FA erfolgreich aktiviert",
    "2faSuccessDisabled": "2FA erfolgreich deaktiviert",
    "resetPasswordTitle": "Passwort zurücksetzen",
    "oldPassword": "Altes Passwort",
    "newPassword": "Neues Passwort",
    "repeatNewPassword": "Neues Passwort wiederholen",
    "otpCode": "2FA-Code",
    "otpPlaceholder": "Authentifikator-Code",
    "updatePassword": "Passwort aktualisieren",

    "passwordSuccess": "Dein Passwort wurde erfolgreich geändert",
    "passwordErrorGeneric": "Etwas ist schiefgelaufen",
    "passwordUpdateFailed": "Aktualisierung fehlgeschlagen",

    "oldPasswordRequired": "Altes Passwort ist erforderlich",
    "newPasswordRequired": "Neues Passwort ist erforderlich",
    "repeatNewPasswordRequired": "Wiederholung des neuen Passworts ist erforderlich",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein",

    "ruleMinLength": "Mindestens 8 Zeichen lang",
    "ruleUniqueChars": "Mindestens 6 unterschiedliche Zeichen erforderlich",
    "ruleDigit": "Mindestens eine Ziffer erforderlich",
    "ruleUppercase": "Mindestens ein Großbuchstabe erforderlich",
    "ruleLowercase": "Mindestens ein Kleinbuchstabe erforderlich",
    "ruleSpecialChar": "Mindestens ein Sonderzeichen erforderlich",
    "ruleDifferentFromOld": "Neues Passwort darf nicht dem alten entsprechen"
  },

  "settings": {
    "title": "Einstellungen",
    "theme": "Design",
    "general": "Allgemeine Einstellungen"
  },

  "user": {
    "add": "Hinzufügen",
    "title": "Benutzer",
    "roles": "Rollen",
    "actions": "Aktionen",
    "username": "Benutzername",
    "email": "E-Mail",
    "language": "Sprache ändern",
    "logout": "Abmelden",
    "profile": "Profil",
    "settings": "Einstellungen",
    "billing": "Abrechnung",
    "faq": "FAQ",
    "helpAndSupport": "Hilfe & Support",
    "projects": "Projekte",
    "account": "Konto",
    "explore": "Entdecken"
  },
  "treeView": {
    "basic": "Einfach",
    "icons": "Symbole",
    "selectable": "Auswählbar",
    "editable": "Bearbeitbar",
    "advanced": "Erweitert"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Senden"
  },
  "spacingPlayground": {
    "value": "Wert",
    "margin": "Rand",
    "padding": "Innenabstand"
  },
  "spacing": {
    "title": "Abstand"
  },
  "cards": {
    "cards": "Karten",
    "fixed": "Fest",
    "floating": "Schwebend",
    "contentText": "Die einzigartigen Streifen von Zebras machen sie zu einem der bekanntesten Tiere.",
    "contentTextLong": "Die einzigartigen Streifen von Zebras machen sie zu einem der bekanntesten Tiere. Sie kommen in einer Vielzahl von Lebensräumen vor, wie Graslandschaften, Savannen, Wäldern, dornigen Buschlandschaften, Bergen und Küstenhügeln. Verschiedene vom Menschen verursachte Faktoren haben die Zebra-Population stark beeinträchtigt, insbesondere die Jagd auf Felle und die Zerstörung ihres Lebensraums. Das Grevy-Zebra und das Bergzebra sind gefährdet. Während Steppenzebras wesentlich zahlreicher sind, ist eine Unterart, das Quagga, ausgestorben.",
    "rowHeight": "Zeilenhöhe",
    "title": {
      "default": "Standard",
      "withControls": "Mit Steuerelementen",
      "customHeader": "Benutzerdefinierter Kopfbereich",
      "withoutHeader": "Ohne Kopfbereich",
      "withImage": "Mit Bild",
      "withTitleOnImage": "Mit Titel auf dem Bild",
      "withCustomTitleOnImage": "Mit benutzerdefiniertem Titel auf dem Bild",
      "withStripe": "Mit Streifen",
      "withBackground": "Mit Hintergrund"
    },
    "button": {
      "main": "Haupt",
      "cancel": "Abbrechen",
      "showMore": "Mehr anzeigen",
      "readMore": "Mehr anzeigen"
    },
    "link": {
      "edit": "Bearbeiten",
      "setAsDefault": "Als Standard festlegen",
      "delete": "Löschen",
      "traveling": "Reisen",
      "france": "Frankreich",
      "review": "Bewertung",
      "feedback": "Feedback hinterlassen",
      "readFull": "Vollständigen Artikel lesen",
      "secondaryAction": "Sekundäre Aktion",
      "action1": "Aktion 1",
      "action2": "Aktion 2"
    }
  },
  "colors": {
    "themeColors": "Themenfarben",
    "extraColors": "Zusätzliche Farben",
    "gradients": {
      "basic": {
        "title": "Schaltflächenverläufe"
      },
      "hovered": {
        "title": "Verläufe beim Hover",
        "text": "15 % Aufhellung auf den ursprünglichen Stil (Verlauf oder Vollfarbe) für den Hover-Zustand."
      },
      "pressed": {
        "title": "Verläufe beim Drücken",
        "text": "15 % Abdunklung auf den ursprünglichen Stil (Verlauf oder Vollfarbe) für den gedrückten Zustand."
      }
    }
  },
  "tabs": {
    "alignment": "Registerkarten-Ausrichtung",
    "overflow": "Überlauf der Registerkarten",
    "hidden": "Registerkarten mit verstecktem Schieberegler",
    "grow": "Registerkarten wachsen"
  },
  "helpAndSupport": "Hilfe & Unterstützung",
  "aboutVuesticAdmin": "Über Vuestic Admin",
  "search": {
    "placeholder": "Suchen..."
  },
  "buttonSelect": {
    "dark": "Dunkel",
    "light": "Hell"
  }
}
